import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumHistoryDateRangePick implements BaseEnumType {
  private static allValues: EnumHistoryDateRangePick[] = []; // make sure this is top-most
  
  public static today = new EnumHistoryDateRangePick(1, "Today", "enum_history_date_range_pick_today");
  public static weekToDate = new EnumHistoryDateRangePick(2, "WeekToDate", "enum_history_date_range_pick_week_to_date");
  public static week = new EnumHistoryDateRangePick(3, "Week", "enum_history_date_range_pick_week");
  public static monthToDate = new EnumHistoryDateRangePick(4, "MonthToDate", "enum_history_date_range_pick_month_to_date");
  public static month = new EnumHistoryDateRangePick(5, "Month", "enum_history_date_range_pick_month");
  public static yearToDate = new EnumHistoryDateRangePick(6, "YearToDate", "enum_history_date_range_pick_year_to_date");
  public static year = new EnumHistoryDateRangePick(7, "Year", "enum_history_date_range_pick_year");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumHistoryDateRangePick.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isToday() { return this === EnumHistoryDateRangePick.today; }
  public isWeekToDate() { return this === EnumHistoryDateRangePick.weekToDate; }
  public isWeek() { return this === EnumHistoryDateRangePick.week; }
  public isMonthToDate() { return this === EnumHistoryDateRangePick.monthToDate; }
  public isMonth() { return this === EnumHistoryDateRangePick.month; }
  public isYearToDate() { return this === EnumHistoryDateRangePick.yearToDate; }
  public isYear() { return this === EnumHistoryDateRangePick.year; }

  public static getValues(): readonly EnumHistoryDateRangePick[] {
    return EnumHistoryDateRangePick.allValues;
  }

  public static getValuesExcept0(): readonly EnumHistoryDateRangePick[] {
    return EnumHistoryDateRangePick.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumHistoryDateRangePick {
    const found = EnumHistoryDateRangePick.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumHistoryDateRangePick - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumHistoryDateRangePick): EnumHistoryDateRangePick {
    const found = name ? EnumHistoryDateRangePick.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumHistoryDateRangePick - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumHistoryDateRangePick>): boolean {
    return this.key === other?.key;
  }
}